import { useEffect, useState } from "react";
import "./App.css";
import { Route, Switch } from "react-router-dom";
import Routes from "../routing/Routes";

import { MainLoader, AuthActions, AuthGState } from "@leap4/frontend";
import { ConnectedProps, useDispatch } from "react-redux";
import { connect } from "react-redux";
import { BACKEND_SERVICE_NAME, meMultiUrl } from "../../config/generals";
import { RootState } from "../../interfaces/root-state.interface";
import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeModeProvider } from "../../theme/ThemeModeProvider";
import { AppShell } from "../layout/AppShell";
import { CampaignScopeProvider } from "../scope/CampaignScopeProvider";

const mapStateToProps = (state: RootState) => ({
    auth: state.auth,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface IProps extends PropsFromRedux {
    auth: AuthGState;
}

const queryClient = new QueryClient();

const App = ({ auth }: IProps) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);

    const email =
        (auth?.user as any)?.email ||
        (auth?.user as any)?.username ||
        (auth?.user as any)?.name ||
        "";

    useEffect(() => {
        (async () => {
            try {
                await AuthActions.loadUser(dispatch, BACKEND_SERVICE_NAME, meMultiUrl);
            } finally {
                setIsLoading(false);
            }
        })();
    }, [dispatch]);

    if (isLoading) {
        return <MainLoader />;
    }

    const routes = (
        <Switch>
            <Route component={Routes} />
        </Switch>
    );

    return (
        <ThemeModeProvider>
            <QueryClientProvider client={queryClient}>
                {auth?.user ? (
                    <CampaignScopeProvider>
                        <AppShell email={email}>{routes}</AppShell>
                    </CampaignScopeProvider>
                ) : (
                    routes
                )}
            </QueryClientProvider>
        </ThemeModeProvider>
    );
};

export default connector(App);
